var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgKindred(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 180,
    height: 180,
    viewBox: "0 0 180 180",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Ellipse",
    fill: "none",
    stroke: "#000000",
    strokeWidth: 8,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M 170 90 C 170 45.81723 134.18277 10 90 10 C 45.817219 10 10 45.81723 10 90 C 10 134.182785 45.817219 170 90 170 C 134.18277 170 170 134.182785 170 90 Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ellipse-copy",
    fill: "#000000",
    fillRule: "evenodd",
    stroke: "#000000",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M 105 90 C 105 81.715729 98.284271 75 90 75 C 81.715729 75 75 81.715729 75 90 C 75 98.284271 81.715729 105 90 105 C 98.284271 105 105 98.284271 105 90 Z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgKindred);
export default __webpack_public_path__ + "static/media/kindred.74bdfae00000b8ae282ff6450c2d18d3.svg";
export { ForwardRef as ReactComponent };